import React, { useEffect } from "react";
import { PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE } from "../../../constants/generalConstants";
import PropTypes from "prop-types";
import PaginatedTable from "../../tables/paginatedTable";
import { servicenowUrl } from "../../../services/apiUtils/config/urls";
import TileAccordion from "../tileAccordion";
import useServiceNowProcurementCases from "../../../services/apiUtils/hooks/useServiceNowProcurementCases";
import ProcurementIncidentsRow from "./procurementIncidentsRow";
import useServiceNowUser from "services/apiUtils/hooks/useServiceNowUser";
import { getSnUserIdFromToken } from "utils/authUtils";
import { serviceNames, SERVICENOW } from "constants/serviceNames";

const ProcurementCasesSection = ({
    isEditing,
    maintenanceMode,
    viewClosed = false,
}) => {
    const {
        procurementCaseList,
        setPagesToLoad,
        loadedPageCount,
        procurementCaseCount,
        errorMessage,
    } = useServiceNowProcurementCases(viewClosed);

    const { serviceNowUser, serviceNowUserIsLoading } = useServiceNowUser();

    const preloadNextPage = (newPage) => {
        if (
            newPage + 1 >= loadedPageCount &&
            procurementCaseCount >
                (newPage + 1) * PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE
        ) {
            void setPagesToLoad(newPage + 2);
        }
    };

    useEffect(() => {
        if (
            loadedPageCount === 1 &&
            procurementCaseCount > PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE
        ) {
            void setPagesToLoad(2);
        }
    }, [loadedPageCount, procurementCaseCount, setPagesToLoad]);

    const snProcurementCasesUrl = () => {
        if (serviceNowUser && !serviceNowUserIsLoading) {
            const snUserId = getSnUserIdFromToken(serviceNowUser);
            if (snUserId) {
                const query = encodeURIComponent(`requested_by=${snUserId}`);
                return `${servicenowUrl}/sn_spend_psd_procurement_request_list.do?sysparm_query=${query}`;
            }
        }
        return `${servicenowUrl}/sn_spend_psd_procurement_request_list.do`;
    };

    return (
        <TileAccordion
            serviceName="Procurement Cases"
            tileName="incidents"
            maintenanceMode={maintenanceMode}
            errorMessage={errorMessage}
            count={procurementCaseCount}
            isEditing={isEditing}
        >
            <PaginatedTable
                totalItems={procurementCaseCount}
                isEditing={isEditing}
                serviceUrl={snProcurementCasesUrl()}
                itemsPerPage={PROCURE_TO_PAY_INCIDENT_ROWS_PER_PAGE}
                service={`${serviceNames[SERVICENOW]}-Procurement`}
                items={procurementCaseList ?? []}
                Row={ProcurementIncidentsRow}
                onPageChange={preloadNextPage}
            />
        </TileAccordion>
    );
};

ProcurementCasesSection.propTypes = {
    isEditing: PropTypes.bool.isRequired,
    maintenanceMode: PropTypes.bool,
    viewClosed: PropTypes.bool,
};

export default ProcurementCasesSection;
